import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Button as MuiButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const StyledButton = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "toolbar",
})<{ toolbar?: boolean }>(({ theme, toolbar }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    textTransform: "none",
    flexShrink: 0,
    paddingLeft: 0,

    "&:hover": {
      backgroundColor: isDark
        ? alpha(theme.palette.common.white, 0.06)
        : theme.palette.common.white,
    },

    ...(toolbar && {
      height: 32,
      minWidth: 0,
      padding: theme.spacing(0, 1.25),
      borderRadius: 999,
      backgroundColor: "transparent",

      "&:hover": {
        backgroundColor: isDark
          ? theme.palette.grey[900]
          : theme.palette.grey[100],
      },

      "& .SortDropdown-content": {
        gap: theme.spacing(0.75),
      },

      "& .SortDropdown-label, & .SortDropdown-value": {
        fontSize: 13,
        lineHeight: 1,
        letterSpacing: "normal",
      },

      "& .SortDropdown-label": {
        fontWeight: 500,
      },

      "& .SortDropdown-value": {
        fontWeight: 600,
      },

      "& .MuiButton-endIcon": {
        marginLeft: theme.spacing(0.75),
        marginRight: 0,
        color: theme.palette.text.secondary,

        "& svg": {
          fontSize: 16,
        },
      },
    }),
  };
});

export const ButtonContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
});

export const SortLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const SortValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
}));

export const MenuItemContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
});

export const ArrowIcon = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: (prop) => prop !== "$open",
})<{ $open: boolean }>(({ $open, theme }) => ({
  transform: `rotate(${$open ? -180 : 0}deg)`,
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shorter,
  }),
}));
